
import QDate from 'quasar/src/components/date/QDate.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';;
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'date-input',

	props: {
		autofocus: {
			type: Boolean,
			default: false
		}
	},

	emits: ['input-value'],

	components: {
		QDate,
		QPopupProxy
	},

	data() {
		return {
			date: '',
			proxyDate: '' // Дата, которую мы выбрали в модалке, но не подтвердили
		};
	},

	methods: {
		inputValue() {
			if (!this.date) return;
			this.$emit('input-value', this.date);
			this.date = '';
		},

		save() {
			this.date = this.proxyDate;
		},

		updateProxy() {
			this.proxyDate = this.date;
		}
	}
});
